exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dialogmsg h1:not(.site-title):before,\n.dialogmsg h2:before {\n  display: none;\n}\n\n.dialogmsg .MuiGrid-container-120 .MuiGrid-item-121{\n  display: flex;\n  justify-content: center;\n}\n\n.dialogmsg .MuiGrid-container-120 .MuiGrid-item-121 button{\n\n}\n", ""]);

